import api from './axios';

function downloadBlob(response, filename) {
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const bulkUploadSales = (file, { month = '', year = '', clearExisting = false } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('month', month);
  formData.append('year', year);
  formData.append('clearExisting', clearExisting ? 'true' : 'false');
  return api.post('/sales/bulk-upload', formData).then((r) => r.data);
};

export const bulkUploadSalesReports = (
  summaryFile,
  itemFiles,
  { month = '', year = '', clearExisting = false, clearChannel = '', clearChannelNot = '' } = {}
) => {
  const formData = new FormData();
  formData.append('summaryFile', summaryFile);
  (Array.isArray(itemFiles) ? itemFiles : [itemFiles]).forEach((f) => formData.append('itemFile', f));
  formData.append('month', month);
  formData.append('year', year);
  formData.append('clearExisting', clearExisting ? 'true' : 'false');
  formData.append('clearChannel', clearChannel);
  formData.append('clearChannelNot', clearChannelNot);
  return api.post('/sales/bulk-upload-reports', formData).then((r) => r.data);
};

export const bulkUploadSalesReturns = (file, { year = '', clearExisting = false } = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('year', year);
  formData.append('clearExisting', clearExisting ? 'true' : 'false');
  return api.post('/sales/bulk-upload-returns', formData).then((r) => r.data);
};

export const listBatches = () => api.get('/sales/batches').then((r) => r.data);

export const deleteBatch = (batchId) =>
  api.delete(`/sales/batches/${encodeURIComponent(batchId)}`).then((r) => r.data);

export const listReturnReviewItems = (params) =>
  api.get('/sales/return-review-items', { params }).then((r) => r.data);

export const exportReturnReviewItemsCsv = async (params) => {
  const response = await api.get('/sales/return-review-items/export', { params, responseType: 'blob' });
  downloadBlob(response, 'return-review-items.csv');
};

export const listSales = (params) => api.get('/sales', { params }).then((r) => r.data);

export const exportSalesCsv = async (params) => {
  const response = await api.get('/sales/export', { params, responseType: 'blob' });
  downloadBlob(response, 'sales-transactions.csv');
};

export const listSalesGrouped = (params) => api.get('/sales/grouped', { params }).then((r) => r.data);

export const exportSalesGroupedCsv = async (params) => {
  const response = await api.get('/sales/grouped/export', { params, responseType: 'blob' });
  downloadBlob(response, 'sales-transaction-detail.csv');
};

export const getMonthlyQuantityPivot = (params) =>
  api.get('/sales/monthly-quantity', { params }).then((r) => r.data);

export const exportMonthlyQuantityPivotCsv = async (params) => {
  const response = await api.get('/sales/monthly-quantity/export', { params, responseType: 'blob' });
  downloadBlob(response, `month-wise-${params?.metric || 'quantity'}.csv`);
};

export const exportMonthlyDetailedCsv = async (params) => {
  const response = await api.get('/sales/monthly-quantity/export-detailed', { params, responseType: 'blob' });
  downloadBlob(response, 'month-wise-detailed.csv');
};

export const getPriceHistory = (params) => api.get('/sales/price-history', { params }).then((r) => r.data);
